/** Status retornados pela API de propostas de orçamento (não confundir com status de centro de custo). */
export const BUDGET_PROPOSAL_STATUS_LABELS: Record<string, string> = {
  Pending: 'Pendente',
  Approved: 'Aprovado',
  Rejected: 'Rejeitado',
  Cancelled: 'Cancelado'
};

export function isBudgetProposalPending(status?: string | null): boolean {
  const normalized = (status || '').trim().toLowerCase();
  return normalized === 'pending' || normalized === 'pendente';
}

export function getBudgetProposalStatusLabel(status?: string | null): string {
  const raw = (status || '').trim();
  if (!raw) {
    return '—';
  }
  return BUDGET_PROPOSAL_STATUS_LABELS[raw] || raw;
}

export function getBudgetProposalStatusBadgeClass(status?: string | null): string {
  const raw = (status || '').trim();
  switch (raw) {
    case 'Pending':
      return 'bg-warning text-dark';
    case 'Approved':
      return 'bg-success';
    case 'Rejected':
      return 'bg-danger';
    case 'Cancelled':
      return 'bg-secondary';
    default:
      return 'bg-secondary';
  }
}

/** GET/POST `.../costcenters/budget-proposals` */
export interface CostCenterBudgetProposal {
  id: number;
  costCenterId: number;
  costCenterCode?: string;
  costCenterName?: string;
  proposedMonthlyBudget?: number;
  proposedAnnualBudget?: number;
  justification?: string;
  requestedByStaffId?: number;
  requestedAt?: string;
  status: string;
  createdAt?: string;
  updatedAt?: string;
  createdBy?: string;
  updatedBy?: string;
  reviewedByStaffId?: number;
  reviewComments?: string;
  reviewedAt?: string;
}

/** POST `.../budget-proposals/{id}/approve` e `.../reject` */
export interface CostCenterBudgetProposalReviewPayload {
  reviewedByStaffId: number;
  reviewComments: string;
  /** Horário da decisão em Brasília (`-03:00`). */
  reviewedAt: string;
}

/** POST `.../costcenters/{costCenterId}/budget-proposals` */
export interface CostCenterBudgetProposalCreate {
  costCenterId: number;
  proposedMonthlyBudget: number;
  proposedAnnualBudget: number;
  justification: string;
  requestedByStaffId: number;
  requestedAt: string;
}

export interface CostCenterBudgetProposalPagedResult {
  items: CostCenterBudgetProposal[];
  page: number;
  pageSize: number;
  totalItems: number;
  totalPages: number;
}

export interface CostCenterBudgetProposalFilters {
  page?: number;
  pageSize?: number;
  status?: string;
  costCenterId?: number;
}
